import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { getItemLinkFieldValue } from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import type { Field } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-colset444',
  templateUrl: './colset444.component.html',
  styleUrls: ['./colset444.component.scss'],
  host: { ngSkipHydration: 'true' },
})
export class Colset444Component implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rowSpacing?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsLeft?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsCenter?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptionsRight?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  readonly order1 = 'order-md-1';
  readonly order2 = 'order-md-2';
  readonly order3 = 'order-md-3';

  readonly cols = 'col col-12 col-md-4 ';

  leftColumn = this.cols;
  centerColumn = this.cols;
  rightColumn = this.cols;

  ngOnInit() {
    this.renderingToModel(this.rendering);
  }

  private renderingToModel(rendering: InnogyComponentRendering | undefined) {
    if (rendering == null || rendering.fields == null) {
      return;
    }

    this.rowSpacing = getItemLinkFieldValue(rendering.fields, 'rowSpacing', '');

    // first set theming options if selected
    this.contentOptionsLeft = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeLeft',
      ''
    );

    this.contentOptionsLeft +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeLeft', '');

    // first set theming options if selected
    this.contentOptionsRight = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeRight',
      ''
    );

    this.contentOptionsRight +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeRight', '');

    // first set theming options if selected
    this.contentOptionsCenter = getItemLinkFieldValue(
      rendering.fields,
      'backgroundThemeCenter',
      ''
    );

    this.contentOptionsRight +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textThemeCenter', '');

    const activateOrderField = rendering.fields['forcedOrder'] as Field;

    // the raw value of a Sitecore checkbox field while checked is '1'
    if (activateOrderField != null && activateOrderField.value) {
      this.leftColumn = this.cols + this.order2;
      this.centerColumn = this.cols + this.order1;
      this.rightColumn = this.cols + this.order3;
    }
  }
}
